<form (ngSubmit)="onSave()" [formGroup]="formGroup">
  <h2 mat-dialog-title>
    <ng-container *ngIf="data.mode === 'edit'; else editDiscountTitle">
      {{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.TITLE' | translate }}
    </ng-container>
    <ng-template #editDiscountTitle>
      {{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.EDIT_TITLE' | translate }}
    </ng-template>
  </h2>

  <mat-dialog-content>
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.NAME_LABEL' | translate }}</glxy-label>
      <glxy-hint>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.NAME_HINT' | translate }}</glxy-hint>
      <input type="text" formControlName="description" matInput />
    </glxy-form-field>

    <glxy-form-field class="type-options">
      <glxy-label>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.TYPE_LABEL' | translate }}</glxy-label>
      <mat-radio-group formControlName="discountType" required>
        <mat-radio-button value="FIXED_AMOUNT_PER_UNIT">
          {{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.TYPE_FIXED_AMOUNT_PER_UNIT' | translate }}
        </mat-radio-button>
        <mat-radio-button value="PERCENT_AMOUNT">
          {{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.PERCENTAGE' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </glxy-form-field>

    <ng-container *ngIf="discountType.value === fixedAmountPerUnitDiscountType; else percentAmount">
      <glxy-form-field [size]="'small'" [bottomSpacing]="'none'" [showLabel]="false" [prefixText]="currencySymbol">
        <input type="number" formControlName="amount" matInput onwheel="this.blur()" required />
      </glxy-form-field>
    </ng-container>
    <ng-template #percentAmount>
      <glxy-form-field [size]="'small'" [bottomSpacing]="'none'" [showLabel]="false" [prefixText]="'%'">
        <input type="number" formControlName="percentAmount" matInput onwheel="this.blur()" required />
      </glxy-form-field>
    </ng-template>

    <ng-container *ngIf="!data.hideDates">
      <glxy-form-field class="duration">
        <glxy-label>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.DURATION' | translate }}</glxy-label>
        <mat-select formControlName="duration" required>
          <mat-option value="forever">{{
            'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.DURATION_FOREVER' | translate
          }}</mat-option>
          <mat-option value="date">{{
            'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.DURATION_CUSTOM' | translate
          }}</mat-option>
        </mat-select>
      </glxy-form-field>

      <ng-container *ngIf="duration.value === 'date'">
        <div class="date-range">
          <glxy-form-field class="start-date">
            <glxy-label>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.START_DATE' | translate }}</glxy-label>
            <glxy-hint>{{
              'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.START_END_UTC' | translate
            }}</glxy-hint>
            <input matInput [matDatepicker]="startPicker" formControlName="startDate" required />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            <glxy-error *ngIf="startDate.hasError('required') && startDate.touched">{{
              'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.START_DATE_HINT' | translate
            }}</glxy-error>
          </glxy-form-field>

          <glxy-form-field>
            <glxy-label>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.END_DATE' | translate }}</glxy-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" [min]="minimumEndDate()" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
            <glxy-error *ngIf="endDate.hasError('matDatepickerMin')">
              {{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.END_DATE_AFTER_START' | translate }}
            </glxy-error>
          </glxy-form-field>
        </div>
      </ng-container>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close>
      {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>
    <button type="submit" mat-flat-button color="primary" [disabled]="isLoading()">
      <glxy-button-loading-indicator [isLoading]="isLoading()">
        {{ 'COMMON.ACTION_LABELS.CONFIRM' | translate }}
      </glxy-button-loading-indicator>
    </button>
  </mat-dialog-actions>
</form>
